import { createContext, useContext } from "react"

interface ProductPageImportContextType {
  hasQuickInfos: boolean
  hasDownloads: boolean
  hasReferences: boolean
}

export const ProductPageImportContext =
  createContext<ProductPageImportContextType | null>(null)

export const useProductPageImportContext = () => {
  const context = useContext(ProductPageImportContext)
  if (!context) {
    throw new Error(
      "useProductPageImportContext must be used within a ProductPageImportProvider"
    )
  }
  return context
}
